export const WoliPopupMixin = {
    computed: {
        isLoadingConversations() {
            return this.popupStore.state.isLoadingConversations;
        },

        isLoadingConversation() {
            return this.popupStore.state.isLoadingConversation;
        },

        isLoadingRename() {
            return this.popupStore.state.isLoadingRename;
        },

        isAssistantResponding() {
            return this.popupStore.state.isAssistantResponding;
        },

        isAssistantTyping() {
            return this.popupStore.state.isAssistantTyping;
        },

        isNewChat() {
            return !this.pendingMessage && !this.isLoadingConversation && !this.messages;
        },

        conversations() {
            return this.popupStore.state.conversations;
        },

        conversationId() {
            return this.popupStore.state.conversationId;
        },

        selectedConversation() {
            return this.popupStore.getters.selectedConversation;
        },

        messages() {
            return this.popupStore.getters.messages;
        },

        pendingMessage() {
            return this.popupStore.state.pendingMessage;
        },

        respondingMessageIndex() {
            return this.popupStore.state.respondingMessageIndex;
        },

        userInput() {
            return this.popupStore.state.userInput;
        },

        conversationContainerElement() {
            return this.popupStore.state.conversationContainerElement;
        },

        renameConversationId() {
            return this.popupStore.state.renameConversationId;
        },

        renameConversationName() {
            return this.popupStore.state.renameConversationName;
        },
    },
};